var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "file-check-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.042,
    height: 21.5,
    viewBox: "0 0 20.042 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7276",
    "data-name": "Path 7276",
    d: "M14.434,4.054l-.468.557Zm3.69,3.563-.468.557Zm2.146,2.538-.639.305h0ZM3.041,20.828l.494-.53h0Zm16.46,0-.494-.53h0Zm-6.365.422H9.407v1.5h3.729ZM2.648,14V10H1.25v4Zm17.246-.437V14h1.4v-.437ZM13.966,4.611l3.69,3.563.935-1.115L14.9,3.5Zm7.326,8.952a9.787,9.787,0,0,0-.383-3.714l-1.277.61a8.547,8.547,0,0,1,.262,3.1ZM17.657,8.174a7.84,7.84,0,0,1,1.975,2.285l1.277-.61a9,9,0,0,0-2.317-2.79ZM9.435,2.75a6.942,6.942,0,0,1,2.527.216l.5-1.4A7.965,7.965,0,0,0,9.435,1.25ZM14.9,3.5a8.52,8.52,0,0,0-2.439-1.931l-.5,1.4a7.431,7.431,0,0,1,2,1.645ZM9.407,21.25a31.283,31.283,0,0,1-4-.14A2.927,2.927,0,0,1,3.536,20.3l-.989,1.061A4.255,4.255,0,0,0,5.222,22.6a32.248,32.248,0,0,0,4.185.153ZM1.25,14a39.77,39.77,0,0,0,.143,4.489,4.883,4.883,0,0,0,1.154,2.87L3.536,20.3a3.37,3.37,0,0,1-.757-2.009A38.6,38.6,0,0,1,2.648,14Zm11.886,8.75A32.247,32.247,0,0,0,17.32,22.6,4.255,4.255,0,0,0,20,21.359L19.007,20.3a2.927,2.927,0,0,1-1.873.812,31.285,31.285,0,0,1-4,.14ZM19.894,14a38.589,38.589,0,0,1-.13,4.289,3.37,3.37,0,0,1-.757,2.009L20,21.359a4.883,4.883,0,0,0,1.154-2.87A39.775,39.775,0,0,0,21.292,14ZM2.648,10a38.6,38.6,0,0,1,.13-4.289A3.37,3.37,0,0,1,3.536,3.7L2.547,2.641a4.882,4.882,0,0,0-1.154,2.87A39.77,39.77,0,0,0,1.25,10ZM9.435,1.25A32.558,32.558,0,0,0,5.229,1.4,4.261,4.261,0,0,0,2.547,2.641L3.536,3.7A2.936,2.936,0,0,1,5.415,2.89a31.608,31.608,0,0,1,4.02-.14Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#9facbe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7277",
    "data-name": "Path 7277",
    d: "M13,2.5V5c0,2.357,0,3.536.732,4.268S15.643,10,18,10h4",
    transform: "translate(-2.708 -1.25)",
    fill: "none",
    stroke: "#9facbe",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7278",
    "data-name": "Path 7278",
    d: "M6,16.5,7.333,18,10,15",
    transform: "translate(-1.646 -1.25)",
    fill: "none",
    stroke: "#9facbe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.7179746bce278c39817a9609bfe8de4e.svg";
export { ForwardRef as ReactComponent };